import React, { FC } from 'react';

import SearchLayout from '../../../../components/layouts/SearchLayout';
import SearchResultsContainer from '../../../../containers/searchResults';
import useEsTextQuery from '../../../../hooks/elasticSearch/useEsTextQuery';
import { useTrackSiteSearch } from '../../../../services/matomo/useTrackSiteSearch';

/**
 * Text search results of a query. Separated into it's own component
 * because it is making a ES query, so not to pollute other components.
 *
 * @returns Elastic Search Layout with text search results
 */
const PageTextSearchResults: FC = () => {
  const esQuery = useEsTextQuery();

  const shouldSkipTracking =
    esQuery.isLoading === true ||
    (esQuery.error !== undefined && esQuery.error !== null);

  useTrackSiteSearch({
    count: esQuery.total,
    searchTerm: esQuery.searchTerm,
    shouldSkipTracking,
  });

  return (
    <SearchLayout>
      <SearchResultsContainer esQuery={esQuery} />
    </SearchLayout>
  );
};

export default PageTextSearchResults;
